import { post } from '@tencent/pmd-network';

/**
 * 获取主理人信息
 * @param options
 */
export function getOwnerInfo(options) {
  return new Promise((resolve, reject) => {
    const reqData = options || {};
    post({
      url: '/pvpesport.sgamenes.nesplayer.nesplayer/QueryPrincipalInfo',
      reqData,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
/**
 * 查询主理人白名单状态
 * @param options
 */
export function getPrincipalWhite(options) {
  return new Promise((resolve, reject) => {
    const reqData = options || {};
    post({
      url: '/pvpesport.sgamenes.principal.principal/GetPrincipalWhite',
      reqData,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
